<template>
  <div class="snippet general-event-config-snippet">
    <div class="form-group row">
      <div class="col-lg-12">
        <label>Event Title *</label>
        <div class="kt-input-icon">
          <input
              type="text"
              class="form-control"
              name="title"
              maxlength="200"
              placeholder="Enter event title"
              :value="item.title"
              @input="updateTitle"
              required
          />
          <ValidationMessages :element="v$.item.title"/>
  
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-lg-12">
        <label>Select Theme  *</label>
        <div class="col-md-10">
              <select name = "theme_setting" class="form-control" @change="updateThemeSetting" placeholder="Select Theme ">
                  <option disabled selected>Select Theme </option>
                  <option v-for="option in themeSettings" :value="option._id" :key="option._id"
                      :selected="(item.theme_settings == option._id)">
                      {{ option.title }}
                  </option>
              </select>
             
            </div>
  
      </div>
    </div>

    <div class="form-group row">
      <div class="col-lg-12">
        <label>Company *</label>
        <v-select
            placeholder="Select company"
            label="company_name"
            @option:selected="updateCompany"
            :modelValue="item.company"
            :reduce="(option) => option._id"
            :options="companiesAll"
        />
        <ValidationMessages :element="v$.item.company"/>
  
      </div>
    </div>
    <div class="form-group row">
      <div class="col-lg-4">
        <label>Enable Listing at AVIAREPS Hub</label>
        <br/>
        <div class="switch switch-sm switch-primary">
          <input-switch name="external_listing"
                        :value="item.external_listing"
                        id="customSwitchesEx"
                        class="custom-control-input"
                        @change="UpdateExternalListing" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import $ from 'jquery';
import InputSwitch from "@/components/Commons/InputSwitch";
import ValidationMessages from "@/components/Commons/Validations/ValidationMessages";
import {
    useVuelidate
} from '@vuelidate/core'
import {
    required,
    email,
} from '@vuelidate/validators'

export default {
  name: "GeneralEventConfigSnippet",
  components: {
    InputSwitch,
    ValidationMessages
  },
  setup() {
        return {
            v$: useVuelidate()
        }
    },
  validations() {
        return {
            item: {
                title: {
                    required,
                },
                company: {
                    required,
                },
                
            }
        };
    },
 
  computed: {
    ...mapGetters("EventsSingle", [
      "item",'themeSettings'
    ]),
    ...mapGetters("CompaniesIndex", { companiesAll: 'all' })
  },
  mounted() {
    const switchers = document.querySelectorAll('.general-event-config-snippet input[data-plugin-ios-switch]')
    switchers.forEach(item => {const elem = new window.theme.PluginIOS7Switch($(item)) })
 
  },
  methods: {
    ...mapActions("EventsSingle", [
      "setCompany",
      "setTitleEdit",
      "setTitle",
      "setExternalListing",
      "setEventThemeSetting"
      
    ]),
    updateCompany(value) {
      this.setCompany(value._id);
    },
    updateTitle(e) {
      this.setTitle(e.target.value);
    },
    UpdateExternalListing(e) {
       this.setExternalListing(e.target.checked);
    },
    updateThemeSetting(e) {
      console.log("e.target.value",e.target.value);
      this.setEventThemeSetting(e.target.value);
    },
  },
}
</script>

<style scoped>

</style>